var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFestival(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.764,
    height: 13.489,
    viewBox: "0 0 13.764 13.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "festival",
    transform: "translate(0 3.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64152",
    "data-name": "Path 64152",
    d: "M161.385,28.5l-.67.67-1.449-1.449a.81.81,0,0,1,1.145-1.145l.795.795c-.006.068-.009.136-.009.205a2.358,2.358,0,0,0,.187.924Z",
    transform: "translate(-154.755 -29.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64153",
    "data-name": "Path 64153",
    d: "M247.51,133l-.492.492v2.673H243.43V133.49l-.48-.48.548-.548a2.37,2.37,0,0,0,3.475,0Z",
    transform: "translate(-236.419 -132.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64154",
    "data-name": "Path 64154",
    d: "M411.42,26.8l-1.462,1.462L409.3,27.6a2.358,2.358,0,0,0,.187-.924c0-.077,0-.152-.011-.227l.8-.8a.81.81,0,0,1,1.145,0h0A.81.81,0,0,1,411.42,26.8Z",
    transform: "translate(-398.297 -28.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64155",
    "data-name": "Path 64155",
    d: "M261.875,302.977a1.883,1.883,0,0,1,.317.027v-1.6a.4.4,0,0,1,.806,0v1.884a1.874,1.874,0,0,1,1.036-.311h.134a1.9,1.9,0,0,1,.209.012v-2.8H260.79v3.047a1.874,1.874,0,0,1,.951-.258Z",
    transform: "translate(-253.779 -295.866)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9443",
    "data-name": "Ellipse 9443",
    cx: 1.567,
    cy: 1.567,
    r: 1.567,
    transform: "translate(6.771 -0.955) rotate(-67.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64156",
    "data-name": "Path 64156",
    d: "M41.75,109.19v-7.5l.708-.1a.4.4,0,1,0-.108-.8l-1.605.217a.4.4,0,1,0,.108.8l.091-.012v7.189a1.877,1.877,0,0,1,.66.293Q41.674,109.233,41.75,109.19Z",
    transform: "translate(-39.309 -101.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64157",
    "data-name": "Path 64157",
    d: "M191.766,433.938a1.075,1.075,0,0,0-.527.137,1.874,1.874,0,0,1,.253.943v.641h.681v-.641a1.874,1.874,0,0,1,.253-.943,1.075,1.075,0,0,0-.527-.137Z",
    transform: "translate(-186.098 -426.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64158",
    "data-name": "Path 64158",
    d: "M1.08,433.937A1.08,1.08,0,0,0,0,435.017v.237a.4.4,0,0,0,.4.4H1.487v-.641a1.874,1.874,0,0,1,.253-.943,1.074,1.074,0,0,0-.527-.137H1.08Z",
    transform: "translate(0 -426.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64159",
    "data-name": "Path 64159",
    d: "M362.433,433.938a1.075,1.075,0,0,0-.527.137,1.874,1.874,0,0,1,.253.943v.641h.681v-.641a1.874,1.874,0,0,1,.253-.943,1.074,1.074,0,0,0-.527-.137Z",
    transform: "translate(-352.177 -426.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64160",
    "data-name": "Path 64160",
    d: "M427.88,433.938h-.134a1.08,1.08,0,0,0-1.08,1.08v.641h1.891a.4.4,0,0,0,.4-.4v-.237A1.08,1.08,0,0,0,427.88,433.938Z",
    transform: "translate(-415.196 -426.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64161",
    "data-name": "Path 64161",
    d: "M257.214,433.938h-.134a1.08,1.08,0,0,0-1.08,1.08v.641h2.294v-.641A1.08,1.08,0,0,0,257.214,433.938Z",
    transform: "translate(-249.118 -426.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64162",
    "data-name": "Path 64162",
    d: "M86.547,433.938h-.134a1.08,1.08,0,0,0-1.08,1.08v.641h2.294v-.641A1.08,1.08,0,0,0,86.547,433.938Z",
    transform: "translate(-83.039 -426.021)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestival);
export default __webpack_public_path__ + "static/media/festival.9c4c530957f000f6102130ff86d6bdd5.svg";
export { ForwardRef as ReactComponent };